import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import * as categoryAPI from '../../lib/api/categoryapi';
import { takeLatest } from 'redux-saga/effects';
import { remove, forEach, indexOf, intersection } from 'lodash';

/**
 * API 서버에 Request 하는 Action Type
 * createRequestSaga 함수에서 제공하고 TYPE, SUCCESS, FAIL 3가지 정의만 가능
 */
const [
    REQ_TYPE_LIST_CATE,
    REQ_TYPE_LIST_CATE_SUCCESS,
    REQ_TYPE_LIST_CATE_FAILURE,
] = createRequestActionTypes('cate/LIST_CATE');

const [
    REQ_TYPE_LIST_CATE3,
    REQ_TYPE_LIST_CATE3_SUCCESS,
    REQ_TYPE_LIST_CATE3_FAILURE,
] = createRequestActionTypes('cate/LIST_CATE3');

const [
    REQ_TYPE_LIST_CATE_FILTER,
    REQ_TYPE_LIST_CATE_FILTER_SUCCESS,
    REQ_TYPE_LIST_CATE_FILTER_FAILURE,
] = createRequestActionTypes('cate/LIST_CATE_FILTER');

// 컴포넌트에서 사용할 선택된 카테고리 설정 액션
const SET_BRAND_CATE_ID = 'cate/SET_BRAND_CATE_ID';
const SET_ACTIVE_BRAND_CATE_ID = 'cate/SET_ACTIVE_BRAND_CATE_ID';
const SET_CUR_SCND_CATE_ID = 'cate/SET_CUR_SCND_CATE_ID';
const SET_ACTIVE_CATE_ID = 'cate/SET_ACTIVE_CATE_ID';
const SET_ACTIVE_FILTER_ID = 'cate/SET_ACTIVE_FILTER_ID';
const RESET_CATE_ERROR = 'caet/RESET_CATE_ERROR';
const SET_CUR_FIRST_CATE_ID = 'cate/SET_CUR_FIRST_CATE_ID';
const RESET_CATE_INFO = 'cate/RESET_CATE_INFO';
const ADD_DEL_CATE3 = 'cate/ADD_DEL_CATE3';
const REMOVE_DEL_CATE3 = 'cate/REMOVE_DEL_CATE3';
const SET_SORT_CATE = 'cate/SET_SORT_CATE';
const SET_CUR_PAGE = 'cate/SET_CUR_PAGE';
const SET_SEARCH_NOW = 'cate/SET_SEARCH_NOW';

/**
 * 견적서 요청 Action - Container 에서 요청
 * 첫번째 인자 - ActionType
 * 두번째 인자 - 리듀서에서 처리 해야 할 Payload : 스토어에서 사용될 값 (생략가능)
 */
export const getCateListAction = createAction(REQ_TYPE_LIST_CATE);
export const getCate3ListAction = createAction(REQ_TYPE_LIST_CATE3, (curSelCateId) => ({ curSelCateId }));
export const getCateFilterListAction = createAction(REQ_TYPE_LIST_CATE_FILTER, (curSelCateId) => ({ curSelCateId }));

// 선택된 카테고리 리스트 정보  : 브랜드 조회시 사용
export const setBrandCateIdAction = createAction(SET_BRAND_CATE_ID);
export const setActiveBrandCateIdAction = createAction(SET_ACTIVE_BRAND_CATE_ID);

// 카테고리 Depth별 선택 정보 저장
export const setCurScndCateIdAction = createAction(SET_CUR_SCND_CATE_ID);
export const setActiveCateIdAction = createAction(SET_ACTIVE_CATE_ID);
export const setActiveFilterIdAction = createAction(SET_ACTIVE_FILTER_ID);

// Error 정보 reset
export const resetCateErrorAction = createAction(RESET_CATE_ERROR);

// 1 Depth Category 선택 저장
export const setCurFirstCateId = createAction(SET_CUR_FIRST_CATE_ID);

// 모든  정보 reset
export const resetCateInfoAction = createAction(RESET_CATE_INFO);

// 3depth 선택 제외 카테고리 저장
export const addDelCate3ListAction = createAction(ADD_DEL_CATE3);
export const removelCate3ListAction = createAction(REMOVE_DEL_CATE3);

// 정렬 버튼 처리
export const setSortAction = createAction(SET_SORT_CATE);

export const setCurPageAction = createAction(SET_CUR_PAGE);

//최초 page loading 시 파라미터 setting시에는 검색하지 않도록 하기위한 추가 parameter
export const setSearchNowAction = createAction(SET_SEARCH_NOW)

/**
 * SAGA API 에서 REST API 호출
 */
const listCateItemsSaga = createRequestSaga(REQ_TYPE_LIST_CATE, categoryAPI.getAllCategory);
const listCate3ItemsSaga = createRequestSaga(REQ_TYPE_LIST_CATE3, categoryAPI.get3DepCategory);
const listFilterItemsSaga = createRequestSaga(REQ_TYPE_LIST_CATE_FILTER, categoryAPI.getFilters);
export function* cateItemsSaga() {
    yield takeLatest(REQ_TYPE_LIST_CATE, listCateItemsSaga);
    yield takeLatest(REQ_TYPE_LIST_CATE3, listCate3ItemsSaga);
    yield takeLatest(REQ_TYPE_LIST_CATE_FILTER, listFilterItemsSaga);
}

/**
 * Store에 저장될 값
 */
const initialState = {
    searchNow: true,
    cateItems: null, // 1 Depth, 2 Depth 카테고리 정보가 있음
    curSelFirstCateId: null, // 선택된 1 Depth 카테고리 ID
    curSelScndCateId: null, // 선택된 2 Depth 카테고리 ID
    cate3depItems: null,
    filterItems: null,
    brandCateIds: null, // 브랜드 정보를 조회하기 위한 복수개의 카테고리 아이디들
    activeBrandCateIds: null, // 브랜드 조회에서 활성화된 복수개의 카테고리 아이디들
    activeCateIds: [], // 3depth 카테고리 선택 저장
    activeFilterIds: [], // 필터 선택 저장
    delCate3Ids: [], // 제외되는 3 depth 카테고리
    sort: 0,
    curPageNum: 1,               //상품 페이지 표시
    cateExist: [],
    error: null
}

const cateItemsReducer = handleActions(
    {
        [REQ_TYPE_LIST_CATE_SUCCESS]: (state, { payload: cateItems }) => {
            //console.log("cateItems = " + JSON.stringify(cateItems));

            let cateData = cateItems.numCatePrdct;
            let cateArray = [];
            if(cateData !== null && cateData !== undefined){
                cateData.forEach(cate1 => {
                    let cate2bucket = cate1.cate2.buckets;
                    cate2bucket.forEach(cate2 => {
                        let cate3bucket = cate2.cate3.buckets;
                        cate3bucket.forEach(cate3 => {
                            let cate = cate1.key*10000+cate2.key*100+cate3.key;
                            cateArray.push(cate);
                        });
                    });

                });

            }
            //console.log("cateArray = " + JSON.stringify(cateArray));
            return ({
                ...state,
                cateItems:cateItems.category,
                cateExist:cateArray,
            })
        },
        [REQ_TYPE_LIST_CATE_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [REQ_TYPE_LIST_CATE3_SUCCESS]: (state, { payload: cate3depItems }) => {
            let target = [];
            cate3depItems.map((cateitem) => {
                const cateid = (cateitem.cate1_id * 10000) + (cateitem.cate2_id * 100) + cateitem.cate3_id;

                target.push(cateitem)
                // JP commented out : 로직 의미 확인필요 TODO
                // if(state.cateExist === null || state.cateExist === undefined || state.cateExist.length === 0){
                //     //return item;
                //     target.push(cateitem);
                // }else{
                //     for(let i = 0 ; i < state.cateExist.length; i++){
                //         let cate2 = state.cateExist[i];
                //         let cate2_t = cateid;
                //         if(cate2 === cate2_t){
                //             target.push(cateitem);
                //             break;
                //         }
                //     }
                // }
            })

            return ({
                ...state,
                cate3depItems:target,
            })
        },
        [REQ_TYPE_LIST_CATE3_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [REQ_TYPE_LIST_CATE_FILTER_SUCCESS]: (state, { payload: filterItems }) => {

            // Filter 정보를 새로 가져오면 모두 Active Filter에 저장 한다.
            let activeFilter = filterItems.map((filterItem) => {
                let filterIdList = filterItem.filter_list.reduce((resultObj, curObj, idx) => {
                    resultObj.push((curObj.filter1_id * 100) + curObj.filter2_id);
                    return resultObj;
                }, [])
                return filterIdList;
            })

            // console.log("activeFilter : " + JSON.stringify(activeFilter));

            return ({
                ...state,
                filterItems,
                activeFilterIds: [].concat.apply([], activeFilter)
            })
        },
        [REQ_TYPE_LIST_CATE_FILTER_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [SET_BRAND_CATE_ID]: (state, { payload: brandCateIds }) => ({
            ...state,
            brandCateIds: brandCateIds,
        }),
        [SET_ACTIVE_BRAND_CATE_ID]: (state, { payload: activeBrandCateIds }) => {

            return ({
                ...state,
                activeBrandCateIds: activeBrandCateIds
            })
        },
        [SET_CUR_SCND_CATE_ID]: (state, { payload: curSelCateId }) => ({
            ...state,
            curSelScndCateId: curSelCateId,
        }),
        [SET_ACTIVE_CATE_ID]: (state, { payload: activeCateIds }) => {

            // console.log("set Acive Cate ID : " + activeCateIds);

            // 추가된 cate id 가 Del 배열에 있으면 삭제 배열에서 삭제 처리
            let dupCateIds = intersection(state.delCate3Ids, activeCateIds);
            // console.log("dupCateIds : " + dupCateIds);

            if (dupCateIds !== null) {
                dupCateIds.forEach(element => {
                    remove(state.delCate3Ids, (curitem) => {
                        return curitem === element;
                    });
                });
            }

            return ({
                ...state,
                activeCateIds: activeCateIds
            })
        },
        [SET_ACTIVE_FILTER_ID]: (state, { payload: activeFilterIds }) => ({
            ...state,
            activeFilterIds: activeFilterIds,
        }),
        [RESET_CATE_ERROR]: state => ({
            ...state,
            error: null,
            cateItems: null
        }),
        [SET_CUR_FIRST_CATE_ID]: (state, { payload: cateid }) => {
            return ({
            ...state,
            curSelFirstCateId: cateid,
            curSelScndCateId: 0, // depth 초기화
        })},
        [RESET_CATE_INFO]: state => {
            return ({
            ...state,
            searchNow: true,
            cateItems: null, // 1 Depth, 2 Depth 카테고리 정보가 있음
            curSelFirstCateId: null, // 선택된 1 Depth 카테고리 ID
            cate3depItems: null,
            filterItems: null,
            brandCateIds: null, // 브랜드 정보를 조회하기 위한 복수개의 카테고리 아이디들
            activeBrandCateIds: null, // 브랜드 조회에서 활성화된 복수개의 카테고리 아이디들
            curSelScndCateId: null, // 3depth 항목을 가져오기 위한 단일 2depth cateId
            activeCateIds: [], // 3depth 카테고리 선택 저장
            activeFilterIds: [], // 필터 선택 저장
            delCate3Ids: [],
            sort: 0,
            curPageNum: 1,
            cateExist: [],
            error: null
        })},
        [ADD_DEL_CATE3]: (state, { payload: cateid }) => {

            // console.log("set Acive Cate ID")
            let srcIds = state.delCate3Ids;
            let idx = indexOf(srcIds, cateid);
            if (idx === -1) {
                srcIds.push(cateid);
            }

            // activeCateIds 에서는 제거 해야 함
            let activeIds = state.activeCateIds;
            idx = indexOf(activeIds, cateid);
            remove(activeIds, (curitem) => { return (curitem === cateid) })

            return ({
                ...state
            })
        },
        [REMOVE_DEL_CATE3]: (state, { payload: cateid }) => {

            // 전체 삭제
            if (cateid === -1) {
                return ({
                    ...state,
                    delCate3Ids: []
                })
            } else {
                // console.log("set Acive Cate ID")
                let srcIds = state.delCate3Ids;
                remove(srcIds, (curitem) => {
                    return (curitem === cateid)
                })

                // activeCateIds 에서는 추가 해야 함
                let activeIds = state.activeCateIds;
                let idx = indexOf(activeIds, cateid);
                if (idx === -1) {
                    activeIds.push(cateid);
                }
                return ({
                    ...state
                })
            }
        },
        [SET_SORT_CATE]: (state, { payload: sort }) => {
            return({
            ...state,
            sort: sort
        })},
        [SET_CUR_PAGE]: (state, { payload: curPageNum }) => {
            return ({
                ...state,
                curPageNum: curPageNum,
            })
        },
        [SET_SEARCH_NOW]: (state, { payload: searchNow }) => {
            return ({
                ...state,
                searchNow: searchNow,
            })
        },
    }
    , initialState);

export default cateItemsReducer;
